import styled from '@emotion/styled';

import { authColors } from 'design-system/tokens';

export const Countdown = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${authColors.textBody};
`;
